import React, { useState, useEffect } from 'react'

// redux
import { connect } from "react-redux";

// icons
import { BiSearch } from "react-icons/bi";

// list view
import OrdersListView from './OrdersListView';

// action
import { setGlobalLoading } from 'redux/actions/actionCommon';

// API
import { getOrders, cancelGetOrdersApi } from 'utlis/Apis/Orders_API';

// react toastify
import { toast } from 'react-toastify';

// custom hooks
import useQueryHook from 'utlis/CustomHooks/useQueryHook';

// react router
import { useHistory } from 'react-router';

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

// pagination
import Pagination from 'components/Pagination';

// helpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions';

function CompletedOrders(props) {
    // props
    const {
        commonToken,
        currentUser,
        setGlobalLoading,

        currentPath,
    } = props

    // consts
    const query = useQueryHook()
    const history = useHistory()

    // states
    const [allOrders, setAllOrders] = useState([])
    const [ordersLoading, setOrdersLoading] = useState([])

    const [paginationLinks, setPaginationLinks] = useState([])

    const [currentPage, setCurrentPage] = useState(1);
    const [currentKeyword, setCurrentKeyword] = useState("");

    const [searchQuery, setSearchQuery] = useState("")

    // setting page
    useEffect(() => {
        const page = query.get('page')
        let keyword = query.get('keyword')

        if (page) {
            // setting page
            setCurrentPage(page)
        } else {
            // setting page
            setCurrentPage(1)
        }

        if (keyword) {
            // setting keyword
            setCurrentKeyword(keyword)
        } else {
            // setting keyword
            setCurrentKeyword("")
        }
    }, [query])


    // getting customer address details
    useEffect(() => {
        // global loading
        setGlobalLoading(true)
        const urlQueries = `?customer_id=${currentUser.userId}&keyword=${currentKeyword}&page=${currentPage}`;

        getOrders(commonToken ?? "", urlQueries).then(res => {
            // global loading
            setGlobalLoading(false)

            const resData = res.data

            // if success
            if (resData.success) {
                setAllOrders(resData.data) // setting all orders data

                // setting pagination links
                setPaginationLinks(resData.links)
            }

            // if error
            if (resData.error) {
                console.log(`${ERROR_WHILE__NAME} getOrders `, resData.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            }

        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getOrders `, err.message);

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // global loading
                    setGlobalLoading(false)
                },
            });
        })

        return () => {
            cancelGetOrdersApi && cancelGetOrdersApi()
        }
    }, [commonToken, currentPage, currentUser, currentKeyword])

    // searching
    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value

        // if serch query has length
        if (searchQueryValue?.length) {
            // setting search query data
            setSearchQuery(searchQueryValue)

            // redirecting to products with search data
            history.push(`/account/orders/all-orders?customer_id=${currentUser.userId}&keyword=${searchQueryValue}&page=1`)
        }

        // if serch query does not have length
        if (!searchQueryValue) {
            // setting search query data
            setSearchQuery("")

            // redirecting to products with search data
            history.push(`/account/orders/all-orders`)
        }
    }, 500)

    return (
        <React.Fragment>
            <div className="order-view">
                <div className="header-view mb-3">
                    <p className="head text-capitalize">All Orders</p>
                    <p className="desc mb-0">Manage all your orders</p>
                </div>

                {/* content-view */}
                <div className="content-view">
                    {/* top view */}
                    <div className="top-view mb-4 pb-4 border-bottom">
                        <div className="inner d-flex">
                            <div className="lt">
                                <div className="search position-relative">
                                    <input
                                        type="text"
                                        className="form-control default-form-input"
                                        placeholder="Search by SKU or Product Name"
                                        defautlValue={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <div className="icon position-absolute">
                                        <BiSearch fontSize="20" />
                                    </div>
                                </div>
                            </div>
                            <div className="rt"></div>
                        </div>
                    </div>

                    <div className="orders-list">
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <thead>
                                    <tr>
                                        <th width={90} className="text-capitalize">
                                            order #
                                        </th>
                                        <th className="text-capitalize">
                                            date
                                        </th>
                                        <th className="text-capitalize">
                                            order total
                                        </th>
                                        <th className="text-capitalize">
                                            payment status
                                        </th>
                                        <th className="text-capitalize">
                                            fullfillment status
                                        </th>
                                        <th className="text-capitalize">
                                            actions
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        /* item */
                                        allOrders?.length ? allOrders.map(item => {
                                            return (
                                                <OrdersListView
                                                    key={item.order_id}

                                                    dataItem={item}
                                                />
                                            )
                                        }) : (
                                            <tr>
                                                <td colSpan={6}>
                                                    <p className="text-center p-2">No orders found</p>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* bottom sec */}
                    <div className="pagination-container d-flex justify-content-center mt-4">
                        <Pagination
                            routeName={`${currentPath}?customer_id=${currentUser.userId}`}
                            paginationLinks={paginationLinks}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}


const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
        currentUser: state.auth.currentUser,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(CompletedOrders);